import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_FUNNELS } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import { FunnelsProvider } from "@/context/funnels.context";
import RoleGuard from "@/guards/RoleGuard";

const FunnelContainer = lazy(() => import("@/pages/funnels/funnel.container"));

const funnelRoutes = [
    {
        path: PATH_FUNNELS,
        element: (
            <AuthGuard>
                <RoleGuard>
                    <DashboardLayout>
                        <Suspense>
                            <Outlet />
                        </Suspense>
                    </DashboardLayout>
                </RoleGuard>
            </AuthGuard>
        ),
        children: [
            {
                element: (
                    <FunnelsProvider>
                        <FunnelContainer />
                    </FunnelsProvider>
                ),
                index: true,
            },
        ],
    },
];

export default funnelRoutes;
